import { z } from 'zod'

export const sophisticatedInvestorAnalysisFormSchema = z.object({
  isInfoTrueChecked: z.boolean().refine((val) => val === true, {
    message: 'Označte prosím, že všetky uvedené informácie sú pravdivé.',
  }),
  isAgreedToTermsChecked: z.boolean().refine((val) => val === true, {
    message: 'Označte prosím, že súhlasíte s podmienkami rámcovej zmluvy.',
  }),
  isAwareOfInvestorRisksChecked: z.boolean().refine((val) => val === true, {
    message:
      'Označte prosím, že som si vedomý dosledkov straty ochrany investora spojenej s postavením nesofistikovaného investora.',
  }),
})

export type SophisticatedInvestorAnalysisFormSchema = z.infer<
  typeof sophisticatedInvestorAnalysisFormSchema
>
